// extracted by mini-css-extract-plugin
export default {"RightNavigation":"CarouselRightNavigation_RightNavigation__Sc9gH"};